import AtomFeatures from "./AtomFeatures";

export default AtomFeatures;
